module.exports = __webpack_public_path__ + "img/buttt.33a51c6a.png";